import React from 'react'
import { Button } from 'react-bootstrap';
import { t } from "i18next";
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../Redux/userReducer';
import { useHistory } from "react-router-dom";
import { setCompany, setCompanyUser, setWorkers } from '../Redux/companyReducer';


function CompanyHeader({ chainId, urlParams, isLoading, setIsLoading, lang }) {
    const dispatch = useDispatch()
    const history = useHistory()
    const company = useSelector((state) => state.company.company)
    const companyUser = useSelector((state) => state.company.companyUser)

    const logout = () => {
        dispatch(setUser(null))
        dispatch(setCompanyUser(null))
        dispatch(setCompany(null))
        dispatch(setWorkers([]))
        setIsLoading(false)
        history.push(`/?chainid=${chainId}&lang=${lang}`)
    }

    const goToMyAccount = () => {
        window.location.href = `/myaccount?chainid=${chainId}&lang=${urlParams.get("lang") || "eng"}`;
    }
    
    return (
        <div className="comp-logged">
            {company && company.companyLogoUrl ?
                <img className='company-logo' src={company.companyLogoUrl}></img> :
                <span className="greeting_txt"></span>
            }
            <span className='greeting' role="application" aria-roledescription={t("greeting")} aria-label={`${t("hello")} ${companyUser.customerFirstName + " " + companyUser.customerLastName}`}>{t("hello")} {companyUser.customerFirstName + " " + companyUser.customerLastName}</span>
            <Button className="company-logout-btn" onClick={goToMyAccount}>{t("goToMyAccount")}</Button>
            <Button className="company-logout-btn" variant="outline-dark" disabled={isLoading} aria-label={t("logout")} onClick={logout}>{t("logout")}</Button>
        </div>
    )
}

export default CompanyHeader